import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "antd";
import { Form } from "components/Form/Form";

import { useLogin } from "./api/loginUser";

import Input from "components/Form/Input/Input";

import "./Login.scss";

const schema = yup.object().shape({
  username: yup.string().required("Username is required!"),
  password: yup.string().required("Password is required!"),
});

const Login = () => {
  const { mutate, isLoading } = useLogin();
  const submitRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    mutate(data);
  };

  const triggerSubmit = () => {
    submitRef.current.click();
  };

  return (
    <div className="Login">
      <div className="LoginBackgroundImage"></div>
      <div className="LoginBackground"></div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input
          register={register}
          type="text"
          name="username"
          placeholder="Username"
          errorMessage={errors?.username?.message}
        />
        <Input
          register={register}
          type="password"
          name="password"
          placeholder="Password"
          errorMessage={errors?.password?.message}
        />
        <button type="submit" hidden={true} ref={submitRef} />
        <Button type="primary" loading={isLoading} onClick={triggerSubmit}>
          Login
        </Button>
      </Form>
    </div>
  );
};

export default Login;
